/**
 * Adds a close ("X") button to Judge.me's floating "reviews tab" widget
 * (.jdgm-revs-tab-btn), which ships with no dismiss control of its own -
 * confirmed by inspecting its live markup (just the favicon/stars/rating,
 * all wrapped in one clickable div that opens the reviews modal, no close
 * affordance anywhere). Per request: dismissing hides it for the rest of
 * that browsing session only (sessionStorage, not localStorage) - it
 * reappears on the visitor's next visit/new tab.
 *
 * Judge.me injects its widget asynchronously (it's an app embed, not
 * theme markup), so this polls briefly for .jdgm-revs-tab-btn to exist
 * rather than assuming it's already in the DOM on script execution -
 * same reasoning as the header hover-menu script's approach to
 * Dawn's own async-loaded pieces elsewhere in this project.
 */
(function () {
  var DISMISS_KEY = 'jdgmRevsTabDismissed';

  if (sessionStorage.getItem(DISMISS_KEY) === 'true') {
    // Hide as early as possible (before Judge.me even renders it) to
    // avoid a flash of the tab on every page load this session.
    var style = document.createElement('style');
    style.textContent = '.jdgm-revs-tab { display: none !important; }';
    document.head.appendChild(style);
    return;
  }

  function addCloseButton(tabButton) {
    if (tabButton.dataset.dismissButtonAdded) return;
    tabButton.dataset.dismissButtonAdded = 'true';

    var closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'jdgm-revs-tab-btn__dismiss';
    closeButton.setAttribute('aria-label', 'Close reviews tab');
    closeButton.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M4 4l16 16M20 4L4 20"/></svg>';

    closeButton.addEventListener('click', function (event) {
      // Without this, the click bubbles to .jdgm-revs-tab-btn's own
      // handler and opens the reviews modal right as it's being closed.
      event.stopPropagation();
      event.preventDefault();
      sessionStorage.setItem(DISMISS_KEY, 'true');
      var wrapper = tabButton.closest('.jdgm-revs-tab');
      if (wrapper) wrapper.style.display = 'none';
    });

    tabButton.appendChild(closeButton);
  }

  // Polling, not a MutationObserver, on purpose: Judge.me's widget is a
  // Vue app (data-v-app in its markup) that mounts its own DOM on its
  // own async schedule - in testing, a MutationObserver on document.body
  // reliably failed to catch that mount (button never appeared) even
  // though the same addCloseButton() call worked immediately when run
  // manually moments later. Polling doesn't care how or when the node
  // shows up, only that it eventually does, so it sidesteps whatever
  // about Vue's mounting process the observer wasn't seeing. Keeps
  // checking indefinitely at a low frequency (cheap - a single
  // querySelector) so it also self-heals if Judge.me ever re-mounts the
  // widget later (e.g. after its own async review-data fetch resolves).
  setInterval(function () {
    var tabButton = document.querySelector('.jdgm-revs-tab-btn');
    if (tabButton) addCloseButton(tabButton);
  }, 500);
})();
